<template>
  <v-app>

    <v-app-bar v-if="!isMobile()" height="230px" color="secondary" flat>
      <v-container class="pa-0">
        <v-row>
          <v-col cols="2" class="mt-3">
            <LocalChanger></LocalChanger>
          </v-col>
          <v-col cols="8" class="pa-0 mt-7">
            <v-img src="@/assets/logoBlack.png" contain :max-height=max_height_logo @click="navigate('/')"
              class="clickable-cursor">
            </v-img>
          </v-col>
          <v-col cols="2" class="mt-3">
            <v-row class="ma-0 pa-0">
              <v-icon @click="navigate('/contact')" class="clickable-cursor">mdi-email</v-icon>
              <p @click="navigate('/contact')" class="ml-1 ma-0 pa-0 clickable-cursor">{{ $t('appbar.contatti') }}</p>
            </v-row>
          </v-col>
        </v-row>

        <v-row justify="center" class="mt-5">
          <v-col cols="auto">
            <v-btn text to="/">
              {{ $t('appbar.homeButton') }}
            </v-btn>
            <v-btn text to="/adv2024">
              {{ $t('appbar.campaignButton') }}
            </v-btn>
            <v-btn text to="/positanocoutureforblitzSS24">
              {{ $t('appbar.nuovaCollezione') }}
            </v-btn>

            <!-- SUB MENU FOR LOOKBOOK1 AND 2-->
            <v-menu text open-on-hover offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn text v-bind="attrs" v-on="on">
                  {{ $t('appbar.collezione2022') }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item to="/positanocoutureforblitzSS23">
                  <v-list-item-title> 23 Positano Couture for Blitz </v-list-item-title>
                </v-list-item>
                <v-list-item to="/blitzSS22">
                  <v-list-item-title> 22 Blitz </v-list-item-title>
                </v-list-item>
                <v-list-item to="/positanocoutureSS22">
                  <v-list-item-title> 22 Positano Couture </v-list-item-title>
                </v-list-item>
                <v-list-item to="/adv">
                  <v-list-item-title> 21 Adv </v-list-item-title>
                </v-list-item>
                <v-list-item to="/menscollection">
                  <v-list-item-title> 21 Man </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-btn text to="/ourstory">
              {{ $t('appbar.chisiamoButton') }}
            </v-btn>
            <v-btn text href="https://positano-couture.myshopify.com/" target="_blank">
              Shop
            </v-btn>
          </v-col>
        </v-row>

      </v-container>


    </v-app-bar>

    <v-app-bar v-if="isMobile()" color="secondary" app flat>
      <v-app-bar-nav-icon v-if="isMobile()" color="c0c0c0" @click="drawer = true"></v-app-bar-nav-icon>
      <v-img src="@/assets/logoBlack.png" contain height="50px" width="100px" @click="navigate('/')"
        class="clickable-cursor">
      </v-img>
      <v-icon @click="navigate('/contact')" class="clickable-cursor">mdi-email</v-icon>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app temporary width="100%" color="secondary">

      <!--
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title class="black--text">Blitz</v-list-item-title>
          <v-list-item-subtitle class="black--text">Moda Positano</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      -->

      <v-row justify="center" class="ma-3">
        <v-col cols="12" class="text-center">
          <h1>Blitz</h1>
          <h3>Moda Positano</h3>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-list rounded nav>
        <v-list-item-group active-class="white--text">
          <v-list-item to="/">
            <v-list-item-icon>
              <v-icon color="black">mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="black--text">{{ $t('appbar.homeButton') }}</v-list-item-title>
          </v-list-item>

          <v-list-item to="/adv2024">
            <v-list-item-icon>
              <v-icon color="black">mdi-camera</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="black--text">{{ $t('appbar.campaignButton') }}</v-list-item-title>
          </v-list-item>

          <v-list-item to="/positanocoutureforblitzSS24">
            <v-list-item-icon>
              <v-icon color="black">mdi-image-multiple</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="black--text">{{ $t('appbar.nuovaCollezione') }}</v-list-item-title>
          </v-list-item>

          <!-- SUB MENU FOR LOOKBOOK1 AND 2 -->
          <v-list-group>
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon color="black">mdi-image-multiple</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="black--text">{{ $t('appbar.collezione2022') }}</v-list-item-title>
            </template>

            <v-list-item to="/positanocoutureforblitzSS23">
              <v-list-item-title class="ml-3 black--text">23 Positano Couture for Blitz</v-list-item-title>
            </v-list-item>
            <v-list-item to="/blitzSS22">
              <v-list-item-title class="ml-3 black--text">22 Blitz</v-list-item-title>
            </v-list-item>
            <v-list-item to="/positanocoutureSS22">
              <v-list-item-title class="ml-3 black--text">22 Positano Couture</v-list-item-title>
            </v-list-item>
            <v-list-item to="/adv">
              <v-list-item-title class="ml-3 black--text">21 Adv</v-list-item-title>
            </v-list-item>
            <v-list-item to="/menscollection">
              <v-list-item-title class="ml-3 black--text">21 Man</v-list-item-title>
            </v-list-item>

          </v-list-group>


          <v-list-item to="/ourstory">
            <v-list-item-icon>
              <v-icon color="black">mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="black--text">{{ $t('appbar.chisiamoButton') }}</v-list-item-title>
          </v-list-item>

          <v-list-item href="https://positano-couture.myshopify.com/" target="_blank">
            <v-list-item-icon>
              <v-icon color="black">mdi-cart</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="black--text">Shop</v-list-item-title>
          </v-list-item>

        </v-list-item-group>
      </v-list>

      <v-divider></v-divider>

      <v-row justify="center" class="ma-3">
        <v-col cols="12" class="text-center">
          <LocalChanger></LocalChanger>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-3">
        <v-col cols="12" class="text-center">
          <v-btn fab dark small color="primary" @click="drawer = false">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      
    </v-navigation-drawer>

    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- If using vue-router -->
      <router-view>
      </router-view>
    </v-main>

    <!--
    <v-footer height="auto"
              color="secondary"
              class="ma-0 py-5 text-center black--text">
      <v-container>
        <v-row justify="center" class="mb-5">
          <v-col cols="12">
            <v-img src="./assets/logoBlack.png" contain :max-height=max_height_logo>
            </v-img>
          </v-col>
        </v-row>

        <v-row justify="center" justify-md="space-around" justify-lg="space-around" justify-xl="space-around">
          <v-col cols="12" sm="7" md="3" lg="3" xl="3">
            <p style="font-size: 24px;">{{ $t('footer.indirizzo') }}</p>
            <p class="mb-0">via stradale, 55</p>
            <p class="mb-0">Positano, Napoli</p>
            <p class="mb-0">Italia</p>
          </v-col>
          <v-col cols="12" sm="7" md="3" lg="3" xl="3">
            <p style="font-size: 24px">{{ $t('footer.contatti') }}</p>
            <p class="mb-0">Tel: 081 123 123 22</p>
            <p class="mb-0">WhatsApp: +39 333 33 33 333</p>
          </v-col>
          <v-col cols="12" sm="7" md="3" lg="3" xl="3">
            <p style="font-size: 24px">{{ $t('footer.social') }}</p>
            <p class="mb-0">blitzmodapositano</p>
            <v-btn
                    v-for="elem in icons"
                    :key="elem.icon"
                    class="mx-4"
                    color="black"
                    icon
                    target="_blank"
                    :href="elem.link"
            >
              <v-icon size="24px">{{ elem.icon }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
-->
    <v-footer height="auto" color="secondary" class="ma-0 py-5 text-center black--text">
      <v-container>
        <v-row justify="center">

          <v-col cols="auto" class="pa-0">
            <p class="ma-0">{{ $t('footer.social') }}</p>
          </v-col>
          <v-col v-for="elem in icons" :key="elem.name" cols="12" sm="12" md="auto" lg="auto" xl="auto" class="pa-0">
            <v-btn class="mx-3" target="_blank" :href="elem.link" text small>
              <v-icon small size="24px">{{ elem.icon }}</v-icon>
              <p class="mb-0 ml-1">{{ elem.name }}</p>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>

    <v-btn v-scroll="onScroll" v-show="fab" fab dark fixed bottom right color="primary" @click="toTop">
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>


  </v-app>
</template>

<script>


import LocalChanger from "./components/LocalChanger";

export default {
  name: 'App',

  components: {
    LocalChanger
  },

  data: () => ({
    icons: [
      {
        icon: 'mdi-facebook',
        link: "https://www.facebook.com/BlitzModaPositano",
        name: "Blitz Moda Positano",
      },
      {
        icon: 'mdi-instagram',
        link: "https://www.instagram.com/blitzmodapositano/",
        name: "Boutique Blitz Moda Positano",
      },
      {
        icon: 'mdi-instagram',
        link: "https://www.instagram.com/positanocouture/",
        name: "POSITANO COUTURE",
      },
    ],
    drawer: false,
    fab: false,
    max_height_logo: "90px",
  }),
  computed: {

  },
  methods: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    navigate(path) {
      if (this.$router.currentRoute.path !== path) {
        this.$router.push(path)
      }
    },
    onScroll(e) {
      if (typeof window === 'undefined') return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 200
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  }
};
</script>

<style>
.clickable-cursor {
  cursor: pointer !important;
}
</style>
